// @flow

export { PixPaymentInformation } from './pix-payment-information';
